import APIInstance from "@/utils/apiConfig";
import { AxiosResponse } from "axios";
import { WorkBookResponse } from "@/models/workbook";

const recentApi = {
  getAll(): Promise<AxiosResponse<WorkBookResponse>> {
    return APIInstance.get("/workbooks/recent");
  },
};

export default recentApi;
